import styled from 'styled-components';

export const TopActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 1rem;
  padding: 1rem 0;
  width: 100%;
  @media (max-width: 1024px) {
    justify-content: center;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  @media (max-width: 1024px) {
    align-items: flex-end;
    flex-wrap: wrap;
    justify-content: flex-end;
  }
`;

export const ActionButton = styled.button`
  background-color: #395905;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  outline: none;
  white-space: nowrap;
  min-width: 120px;

  &:hover:not(:disabled) {
    background-color: #052959;
    box-shadow: 0 4px 8px rgba(5, 41, 89, 0.2);
  }

  &:active:not(:disabled) {
    box-shadow: 0 2px 4px rgba(5, 41, 89, 0.2);
  }

  &:focus:not(:disabled) {
    box-shadow: 0 0 0 3px rgba(57, 89, 5, 0.3);
  }

  &:disabled {
    background-color: #9ca3af;
    color: #d1d5db;
    cursor: not-allowed;
    opacity: 0.6;
    transform: none;
    box-shadow: none;
  }

  &:disabled:hover {
    background-color: #9ca3af;
    transform: none;
    box-shadow: none;
  }
`;
